module.exports = __webpack_public_path__ + "static/media/bg-2.70497b68.jpg";